import { Grid } from "@mui/material"
import { generateCloudflareImageUrl } from "services/cloudflare"

export const BranchOfficeCard = ({ t, item, actions = null }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
        {item.logo ?
          <img src={generateCloudflareImageUrl(item.logo)} style={{ width: "100%", maxWidth: 200 }} />
          : <img src="/no-image.png" style={{ width: "100%", maxWidth: 200 }} />
        }
      </Grid>
      <Grid item xs={12} md={9}>
        <p><b>{t('branchoffice_card_name')}: </b>{item.name}</p>
        <p><b>{t('branchoffice_card_address')}: </b>{item.address}</p>
        <p><b>{t('branchoffice_card_city')}: </b>{item.city}</p>
        <p><b>{t('branchoffice_card_state')}: </b>{item.state}</p>
        <p><b>{t('branchoffice_card_postalcode')}: </b>{item.zip_code}</p>
        <p><b>{t('branchoffice_card_phone')}: </b>{item.phone}</p>
        <p><b>{t('branchoffice_card_cellphone')}: </b>{item.whatsapp}</p>
        <p><b>{t('branchoffice_card_email')}: </b>{item.email}</p>
        <div style={{ textAlign: "end" }}>{actions}</div>
      </Grid>
    </Grid>
  )
}